<section id="homepage-groove">
    <section class="section-container-banner">
        <fitscovery-ui-groove-banner [partner]="partner"></fitscovery-ui-groove-banner>
    </section>

    <!-- 1st Section -->
    <section class="section-container">
        <fitscovery-ui-groove-section-odd [partner]="partner" [imageDescription]="imageDescriptions[0]"></fitscovery-ui-groove-section-odd>
    </section>

    <!-- 2nd Section -->
    <section class="section-container">
        <fitscovery-ui-groove-section-even [partner]="partner" [imageDescription]="imageDescriptions[1]"></fitscovery-ui-groove-section-even>
    </section>

    <!-- 3rd Section -->
    <section class="section-container">
        <fitscovery-ui-groove-section-odd [partner]="partner" [imageDescription]="imageDescriptions[2]"></fitscovery-ui-groove-section-odd>
    </section>
    
    <fitscovery-ui-groove-section-last [partner]="partner"></fitscovery-ui-groove-section-last>
</section>